  $(document).ready(function() {
    var colTabSlider = $('.col-tab-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint:550,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    $('.collection-tab-button').click(function(e){
      e.preventDefault();
      var currentIndex = $(this).index();
      $(this).addClass('active').siblings().removeClass('active');
      $('.collection-tab-data').eq(currentIndex).addClass('active').siblings().removeClass('active');
      colTabSlider.slick('refresh')
    })
  });